import { Area } from '../models/filter/location/area/Area';
import { Continent } from '../models/filter/location/continent/Continent';
import { Country } from '../models/filter/location/country/Country';

import { ILocationRepository } from '../interfaces/presenters.interfaces';

import { areasAll } from '@studyportals/static-domain-data/areas/areas';
import { continentsAll } from '@studyportals/static-domain-data/continents/continents';
import { countriesAll } from '@studyportals/static-domain-data/countries/countries';
import { countryGetPath } from '@studyportals/static-domain-data/countries/country-get-path';
import { countryIsEea } from '@studyportals/static-domain-data/countries/country-is-eea';
import { areasAvailableForCountry } from '@studyportals/static-domain-data/areas/areas-available-for-country';

class LocationRepository implements ILocationRepository {
	public getContinents(): Continent[] {
		const continents: Continent[] = [];

		for (const item of continentsAll) {
			continents.push(new Continent(item.id, item.name));
		}

		return continents;
	}

	public getAreas(): Area[] {
		const areas: Area[] = [];

		for (const item of areasAll) {
			areas.push(new Area(item.id, item.name, item.countryId));
		}

		return areas;
	}

	public getCountries(): Country[] {
		const countries: Country[] = [];

		for (const item of countriesAll) {
			const country = new Country(
				item.id,
				item.name,
				areasAvailableForCountry(item.id),
				countryGetPath(item.id) ?? '',
				countryIsEea(item.id),
			);

			countries.push(country);
		}

		return countries;
	}
}

export default new LocationRepository();
